import { ArrowRight, BarChart3, BookOpen, CheckCircle, Zap } from 'lucide-react';
import React from 'react';
import './Mission.scss'
import { Link } from 'react-router-dom';

const Mission = () => {
  return (
    <section className="mission">
      <div className="mission-container">
        <div className="mission-header">
          <h2>Our Mission</h2>
          <p>Learn and Grow with FNOTrader</p>
        </div>

        <div className="mission-content">
          <div className="left-content">
            <div className="description">
              <p>At FNOTrader, our mission is to empower Futures and Options (F&O) traders with unique market insights, unconventional charts, and other essential tools needed to navigate the markets with unparalleled confidence and success in the dynamic world of F&O Trading.</p>
              <p>We simplify market analysis and trade execution through our trader-focused products, Discover and QuikTrade.</p>
            </div>
            
            <div className="features">
              <div className="feature-item">
                <CheckCircle />
                <div className="feature-text">
                  <h3>Real-time Analysis</h3>
                  <p>Advanced market insights and data visualization</p>
                </div>
              </div>
              <div className="feature-item">
                <CheckCircle />
                <div className="feature-text">
                  <h3>Professional Tools</h3>
                  <p>Enterprise-grade trading and analysis tools</p>
                </div>
              </div>
              <div className="feature-item">
                <CheckCircle />
                <div className="feature-text">
                  <h3>Learning Resources</h3>
                  <p>Comprehensive educational content and mentorship</p>
                </div>
              </div>
            </div>
          </div>

          <div className="right-content">
            <div className="card">
              <div className="card-items">
                <div className="card-item">
                  <div className="icon-wrapper">
                    <BookOpen />
                  </div>
                  <div className="item-text">
                    <h3>Getting Started</h3>
                    <p>Learn the basics of F&O trading</p>
                  </div>
                </div>

                <div className="card-item">
                  <div className="icon-wrapper">
                    <Zap />
                  </div>
                  <div className="item-text">
                    <h3>Advanced Strategies</h3>
                    <p>Master complex trading techniques</p>
                  </div>
                </div>

                <div className="card-item">
                  <div className="icon-wrapper">
                    <BarChart3 />
                  </div>
                  <div className="item-text">
                    <h3>Market Analysis</h3>
                    <p>Deep dive into market mechanics</p>
                  </div>
                </div>
              </div>

              <Link to="/pricing">
              <button className="cta-button">
                <span>Start Your Journey</span>
                <ArrowRight />
              </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;